import React from 'react';

// Official GOBRA logo extracted from the brand manual.
// Green variant for light backgrounds; white variant for dark/hero backgrounds.
export const GobraMark = ({ className = '', variant = 'dark' }) => (
  <img
    src={`${process.env.PUBLIC_URL || ''}/brand/gobra_mark_${variant === 'light' ? 'white' : 'green'}.png`}
    alt="GOBRA"
    className={className}
  />
);

const Logo = ({ variant = 'dark', compact = false, className = '' }) => {
  const src = `${process.env.PUBLIC_URL || ''}/brand/gobra_lockup_${variant === 'light' ? 'white' : 'green'}.png`;
  const markSrc = `${process.env.PUBLIC_URL || ''}/brand/gobra_mark_${variant === 'light' ? 'white' : 'green'}.png`;
  return (
    <div className={`flex items-center ${className}`}>
      {compact ? (
        <img src={markSrc} alt="GOBRA" className="h-9 w-auto" />
      ) : (
        <img src={src} alt="GOBRA Capital Real Estate" className="h-7 md:h-8 w-auto" />
      )}
    </div>
  );
};

export default Logo;
